import React from 'react';

const GamesNotesSection = ({ notes }) => {
  return (
    <section aria-labelledby="games-notes-title" className="mb-20">
      <div className="bg-gradient-to-br from-slate-50 via-white to-blue-50 p-8 rounded-xl border border-slate-200 shadow-lg site-card shadow-slate-200/70">
        <h2 id="games-notes-title" className="text-3xl font-bold text-gray-900">
          Notas rapidas
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Informacoes importantes para uma experiencia tranquila.
        </p>
        <ul className="mt-6 space-y-3 text-slate-600 list-disc list-inside">
          {notes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default GamesNotesSection;
